import {UmpireComponent} from '../umpire-component';
import {UmpirePageType} from '../umpire-page-type';
import {UmpireComponentType} from '../umpire-component-type';
import {UmpirePublicationOptions} from '../umpire-publication-options';
import {Language} from '../umpire-language-service';

export class UmpirePage implements UmpirePublicationOptions {
  id!: string;

  type = 'page' as const;

  client_id!: string;

  created_at!: Date | string;

  page_type!: UmpirePageType;

  components!: Partial<UmpireComponent<UmpireComponentType>>[];

  publication_time!: string | null;

  published_at!: string | null;

  is_draft!: boolean;

  slug!: string | null;

  locale!: Language;
}
